import {
  IChangeItem,
  INormalizedChangeItem,
  NORMALIZED_CHANGE_ITEM_TYPE,
} from "types/laundry"

interface OBJ {
  [key: number]: NORMALIZED_CHANGE_ITEM_TYPE
}

const TYPES: OBJ = {
  1: NORMALIZED_CHANGE_ITEM_TYPE.TEXT,
  8: NORMALIZED_CHANGE_ITEM_TYPE.IMG,
  9: NORMALIZED_CHANGE_ITEM_TYPE.LOCATION,
  7: NORMALIZED_CHANGE_ITEM_TYPE.WASH_TYPE,
  6: NORMALIZED_CHANGE_ITEM_TYPE.ADDITIONAL_SERVICE,
}

const getType = (type: number) => {
  return TYPES[type] || NORMALIZED_CHANGE_ITEM_TYPE.TEXT
}

export const normalizeChangesHistory = (changesHistory: IChangeItem[]) => {
  const newValues: INormalizedChangeItem[] = []
  const oldValues: INormalizedChangeItem[] = []

  changesHistory.forEach((changeHistory: IChangeItem) => {
    newValues.push({
      field: changeHistory.field,
      value: changeHistory.newValue || "",
      type: getType(changeHistory.type),
      typeId: changeHistory.type,
    })
    oldValues.push({
      field: changeHistory.field,
      value: changeHistory.oldValue || "",
      type: getType(changeHistory.type),
      typeId: changeHistory.type,
    })
  })

  return { newValues, oldValues }
}
